module.exports = __webpack_public_path__ + "img/ray-receiver.3815abf0.png";